import { render, staticRenderFns } from "./OurRange.vue?vue&type=template&id=fa96ad8a&scoped=true&"
import script from "./OurRange.vue?vue&type=script&lang=js&"
export * from "./OurRange.vue?vue&type=script&lang=js&"
import style0 from "./OurRange.vue?vue&type=style&index=0&id=fa96ad8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa96ad8a",
  null
  
)

export default component.exports